import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'tabela-paginacao',
  templateUrl: './tabela-paginacao.component.html',
  styleUrls: ['./tabela-paginacao.component.scss']
})
export class TabelaPaginacaoComponent implements OnInit, OnChanges {

  @Input() colunas: Array<any> = [];
  @Input() dados: Array<any> = [];
  @Input() filtragemDados: any;

  @Input() mensagemTabelaSemRegistros: string = "Nenhum registro foi localizado";

  @Output() onPaginaMudou: EventEmitter<any> = new EventEmitter<any>();

  dadosPaginacao: Array<any> = [];

  page: number = 1;
  itemsPerPage: number = 10;
  maxSize: number = 4;
  numPages: number = 1;
  length: number = 0;
  data: Array<any> = [];

  paging: boolean = true;

  changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  onChangeTable(page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    this.dadosPaginacao = page && this.paging ? this.changePage(page, this.data) : this.data;
    this.length = this.data.length;
    this.onPaginaMudou.emit(this.dadosPaginacao);
  }

  setItemsPerPage(itemsPerPage: number) {
    this.itemsPerPage = itemsPerPage;
    this.onChangeTable();
  }

  filterData(filter: any = this.filtragemDados) {

    if (filter && filter.columns) {
      this.data = this.dados.filter((item: any) => {

        let isPossuiCampoComValor = false;

        for (var i = 0; i < filter.columns.length; i++) {
          if (item[filter.columns[i]] != undefined && item[filter.columns[i]] != null && item[filter.columns[i]].toUpperCase().match(filter.value.toUpperCase())) {
            isPossuiCampoComValor = true;
            break;
          }
        }

        return isPossuiCampoComValor;
      });

      this.length = this.data.length;
      this.onChangeTable();
    }
  }

  constructor() {

  }

  ngOnInit() {
    this.dadosPaginacao = this.dados;
    this.data = this.dados;
    this.length = this.data.length;
    this.onChangeTable();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.filtragemDados) {
      this.filterData(this.filtragemDados);
    }

    if (changes.dados) {
      this.dadosPaginacao = this.dados;
      this.data = this.dados;
      this.length = this.data.length;

      if (this.filtragemDados) {
        this.filterData();
      } else {
        this.onChangeTable();
      }
    }

  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/tabela-paginacao/tabela-paginacao.component.ts